<template>
  <div class="module-block" :style="getStyle" :class="{ 'is-moble': $store.getters.isMobile, 'no-padding': noPadding }">
    <div class="module-block__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModuleBlock',
  props: {
    noPadding: {
      type: Boolean,
      default: false
    },
    maxContentWidth: {
      type: Number,
      default: 1280
    }
  },
  computed: {
    getStyle() {
      return {
        '--max-content-width': this.maxContentWidth + 'px'
      }
    }
  }
}
</script>

<style lang="less">
.module-block {
  padding: 30px;
  position: relative;
  margin: 0 auto;
  max-width: var(--max-content-width);
  &__content {
    margin: 0 auto;
  }
  &.is-moble {
    padding: 10px 5px;
    border-radius: 10px;
  }
  &.no-padding {
    padding: 0 !important;
  }
}

.stand-alone-mode {
  .module-block {
    background: var(--module-bg-color);
    border-radius: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }
}

</style>
